import React from 'react';

import url from 'components/url';

import { isEmptyResult } from '../Utils';

import EmptyResults from './EmptyResults';
import SearchList from './SearchList';
import { SearchResultsProps } from './SearchResultsContainer';

interface Props {
  searchResults: SearchResultsProps;
  searchTerm?: string;
}

const SearchResults = ({ searchResults, searchTerm }: Props) => {
  const { jobsListView, estimatesListView, customersListView } = url;

  const jobsUrl = `${jobsListView.path}?search_term=${searchTerm}`;
  const estimatesUrl = `${estimatesListView.path}?search_term=${searchTerm}`;
  const customersUrl = `${customersListView.path}?search=${searchTerm}`;

  if (isEmptyResult(searchResults)) {
    return (
      <EmptyResults
        primaryText="We couldn't find any matches for your search"
        secondaryText="Try different keywords, or ones that are more general"
      />
    );
  }

  return (
    <>
      {searchResults?.jobs?.length > 0 && <SearchList type="Jobs" list={searchResults.jobs} moreResultsUrl={jobsUrl} />}
      {searchResults?.estimates?.length > 0 && (
        <SearchList type="Estimates" list={searchResults.estimates} moreResultsUrl={estimatesUrl} />
      )}
      {searchResults?.customers?.length > 0 && (
        <SearchList type="Customers" list={searchResults.customers} moreResultsUrl={customersUrl} />
      )}
      {searchResults?.equipment?.length > 0 && <SearchList type="Equipment" list={searchResults.equipment} />}
    </>
  );
};

export default SearchResults;
